import React, { useState } from "react";
import axios from "axios";


const useClassifyStructureTypeCarousel = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getClassifyStructureTypeCarouselData = (params) => {
        // const modifiedParams = {
        //     ...params,
        //     judge: 'judge_time' // 或指定你想要的值
        // };
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/system/frontend/classify_structure_type_carousel_all', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data,
                    data: data.data.map(item => (
                        {
                            ...item,
                            children: undefined
                        }
                    ))
                }
            });
    }
    const postClassifyStructureTypeCarouselData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/system/backend/classify_structure_type_carousel',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchClassifyStructureTypeCarouselData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/system/backend/classify_structure_type_carousel',
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteClassifyStructureTypeCarouselData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/system/backend/classify_structure_type_carousel',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        ClassifyStructureTypeCarouselData: data,
        getClassifyStructureTypeCarouselData,
        postClassifyStructureTypeCarouselData,
        patchClassifyStructureTypeCarouselData,
        deleteClassifyStructureTypeCarouselData
    }
}
export { useClassifyStructureTypeCarousel }
